import {Routes} from '@angular/router';
import {XxConfigPage} from './page/overview/config/xx-config.page';
import {XxTablePage} from './page/overview/tables/xx-table.page';
import {XxWidgetPage} from './page/overview/widgets/xx-widget.page';
import {XxPersonExternalFlatComponent} from './page/overview/widgets/xx-person-external-flat.component';
import {XxPersonExternalTypedComponent} from './page/overview/widgets/xx-person-external-typed.component';
import {XxPersonDataComponent} from './page/overview/widgets/xx-person-data.component';
import {XxPlaygroundShellComponent} from './page/overview/playground/xx-playground-shell.component';
import {XxTestComponentComponent} from './page/testComponent/test-component.component';
import {XxFormLogicComponent} from './page/overview/form-logic/xx-form-logic.component';
import {XxFormExternalSaveTestPage} from './page/test/xx-form-external-save-test.page';
import {XxAutosaveFocusTestPage} from './page/test/xx-autosave-focus-test.page';


export function XxSubRoutes() : Routes {

    /**
     *
     * path:
     * Prefix of the module will always be added to the path name
     *
     *      Example
     *      path: "addresses" => route path "ad/addresses" !
     * ------------------------------------------------------------------
     *
     * canActivate:
     * The authentication guard MsalGuard will be added automatically!
     * ------------------------------------------------------------------
     *
     * component:
     * Added components need to be from type "Page"!
     * ------------------------------------------------------------------
     *
     */
    const routes = [
        {path: 'xx/config', component: XxConfigPage},
        {path: 'xx/table', component: XxTablePage},
        {path: 'xx/testComponent', component: XxTestComponentComponent},
        {path: 'xx/widget', component: XxWidgetPage},
        // TM-1000001960: Clean-Core External Side-Car — QL flatten display (#4)
        {path: 'xx/external-flat', component: XxPersonExternalFlatComponent},
        // TM-1000001960: Clean-Core External Side-Car — typed QL flatten display (#5)
        {path: 'xx/external-typed', component: XxPersonExternalTypedComponent},
        // TM-1000001960: Clean-Core Internal Side-Car — typed person-data display (#3)
        {path: 'xx/person-data', component: XxPersonDataComponent},
        // TM-1000001960: Unified Side-Car Playground — single route, 3 tabs
        // (QL-Demos / Widgets / uf-Erfassung). The former standalone playground
        // (XxSidecarPlaygroundComponent) is now embedded as the first tab.
        {path: 'xx/playground', component: XxPlaygroundShellComponent},
        // Form-Logic Playground: one cc.FormLogic scenario per observable effect, each on its own
        // XxGenericTestType, rendered through both the with-*Form and without-*Form instance family.
        {path: 'xx/form-logic', component: XxFormLogicComponent},
        // Caller-owned save: the page suppresses the form footer, drives the write via save() and
        // watches dirty / valid / complete / submittable live.
        {path: 'xx/test/external-save', component: XxFormExternalSaveTestPage},
        // @ticket TM-1000002003: Autosave ohne Fokusverlust — A/B of the inPlaceUpdate flag against an
        // in-memory mock CRUD service, with a live focus/caret diagnostics panel.
        {path: 'xx/test/autosave-focus', component: XxAutosaveFocusTestPage},
    ];

    return routes;

}
